module.exports = __webpack_public_path__ + "static/media/fish-tiktok-1.d17e7c10.jpg";